import appConfig from '../../../config/app';
import { Observable } from 'rxjs';

const apiRoot = appConfig.apiUrl;

const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=UTF-8'
};

export default {

    get (url, skipAuth = false, skipApiRoot = false) {
        let httpMethod = "GET";

        if (!skipAuth) {
           let authToken = localStorage.getItem('AuthToken');
            if (authToken) {
                headers['Authorization'] = `Bearer ${authToken}`;
            }
        }

        const config = {
            httpMethod,
            headers
        };

        const urlPrefix = skipApiRoot ? '' : apiRoot;

        return new Observable((observer) => {
              fetch(urlPrefix + url, config)
                  .then(response => response.json().then(json => {
                      if (json.success === false) {
                          if (response.status == 400 || json.error) {
                              observer.error({ code: json.code, error: json.error });
                              return;
                          }
                          observer.error({ code: json.code, error: json.data });
                          return;
                      }

                      observer.next(json);
                      observer.complete();
                  }))
                  .catch(error => {
                      observer.error(error);
                  });
          });
    }
}


// WEBPACK FOOTER //
// ./infrastructure/http/httpClient/index.js